enum MouvementActionType {
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  UPDATE_MOUVEMENT = 'UPDATE_MOUVEMENT',
  DUPLIQUER = 'DUPLIQUER',
  SHOW_MOUVEMENT = 'SHOW_MOUVEMENT',
}

export default MouvementActionType;
